import { axios } from '@Root/API'

export const deleteApplications = applicationId => {
  return axios.delete(`delete-student-application/${applicationId}`)
}